<template>
  <div>
    <div class="flex flex-col lg:flex-row">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-3 h-full">
          <div class="flex justify-end items-center p-5">
            <form class="flex">
              <input
                type="text"
                name="lead_search"
                id="lead_search"
                v-model="searchString"
                placeholder="Search"
                class="border-2 rounded-l-xl px-4 py-2 w-[80%] lg:w-[230px] outline-none"
              />
              <button
                type="submit"
                class="bg-blues py-1 rounded-r-xl text-white px-5"
              >
                <!-- <img src="@/assets/search.webp" alt="" srcset="" class="w-6 h-6"> -->

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  class="w-7 h-7"
                  viewBox="0,0,256,256"
                >
                  <g
                    fill="#fbf7f7"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M21,3c-9.37891,0 -17,7.62109 -17,17c0,9.37891 7.62109,17 17,17c3.71094,0 7.14063,-1.19531 9.9375,-3.21875l13.15625,13.125l2.8125,-2.8125l-13,-13.03125c2.55469,-2.97656 4.09375,-6.83984 4.09375,-11.0625c0,-9.37891 -7.62109,-17 -17,-17zM21,5c8.29688,0 15,6.70313 15,15c0,8.29688 -6.70312,15 -15,15c-8.29687,0 -15,-6.70312 -15,-15c0,-8.29687 6.70313,-15 15,-15z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </button>
            </form>
          </div>
          <div class="overflow-x-auto">
            <table class="table-auto w-full">
              <thead>
                <tr>
                  <th
                    class="p-4 border text-center border-r text-textblues whitespace-nowrap"
                  >
                    S NO
                  </th>
                  <th class="p-4 border text-center border-r text-textblues">
                    Name
                  </th>
                  <th class="p-4 border text-center border-r text-textblues">
                    Email
                  </th>

                  <th
                    class="p-4 border text-center border-r text-textblues whitespace-nowrap"
                  >
                    Active
                  </th>

                  <th
                    class="p-4 border text-center border-r text-textblues whitespace-nowrap"
                  >
                    Last Active
                  </th>

                  <th class="p-4 border text-center border-r text-textblues">
                    Signed Up On
                  </th>
                </tr>
              </thead>

              <tbody v-if="studentInfo">
                <tr
                  v-for="student in studentdetails"
                  :key="student.students_email"
                >
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ index + 1 }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p v-if="student.students_name" class="text-primary">
                      {{ student.students_name }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                  <td
                    class="p-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p v-if="student.students_email" class="text-primary">
                      {{ student.students_email }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                  <td
                    class="p-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <template
                      v-if="
                        student.students_Status !== null &&
                        student.students_Status !== undefined
                      "
                    >
                      <span
                        :class="
                          student.students_Status
                            ? 'bg-green-300 text-green-900 px-2 py-1 rounded'
                            : 'bg-red-300 text-red-900 px-2 py-1 rounded'
                        "
                      >
                        {{ student.students_Status ? "Joined" : "Invited" }}
                      </span>
                    </template>
                    <template v-else>
                      <p class="text-primary">NA</p>
                    </template>
                  </td>

                  <td
                    class="p-4 border-b text-center border-r whitespace-nowrap"
                  >
                    <p v-if="student.user_Last_login" class="text-primary">
                      {{ student.user_Last_login }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p v-if="student.user_date_joined" class="text-primary">
                      {{ student.user_date_joined }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="w-full">
                  <td colspan="8" class="text-center py-6">
                    <div class="w-full flex justify-center items-center">
                      No Data Found
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import SideBar from "@/components/Admin/SideBar.vue";
// import FlashMessage from "@/components/FlashMessage.vue";
import { ref, computed } from "vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  setup() {
    const searchString = ref("");
    const studentInfo = ref(null);
    const studentdetails = computed(() => {
      let result = [];
      if (searchString.value) {
        result = studentInfo.value.filter((el) =>
          el.students_name
            .toLowerCase()
            .includes(searchString.value.toLowerCase()),
        );
      } else {
        result = studentInfo.value;
      }
      return result;
    });
    return {
      studentInfo,
      searchString,
      studentdetails,
    };
  },
  data() {
    return {
      actived: "active",
    };
  },
  computed: mapGetters(["userInfo"]),
  components: {
    Header,
    SideBar,
    // FlashMessage,
  },
  // created() {

  //   axios.get(`${process.env.VUE_APP_API}/studentsdetaill/?Key=${this.userInfo.token_key}`)
  //     .then(response => {
  //       this.studentInfo = response.data.data
  //       console.log(this.studentInfo)
  //       let uniqueRecords = []
  //       let uniqueRecords_id = []
  //       this.studentInfo.forEach(record => {
  //         if (uniqueRecords_id.indexOf(record.students_email) === -1) {
  //           uniqueRecords.push(record)
  //           uniqueRecords_id.push(record.students_email)
  //           this.studentInfo = uniqueRecords

  //         }
  //       })
  //     })

  // },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
